"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputStyles = exports["default"] = exports.Input = void 0;
require("core-js/modules/es.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ui = require("@evidation/ui");
var _AccessibleInputLabel = _interopRequireDefault(require("./AccessibleInputLabel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["className", "style", "inputStyle"],
  _excluded2 = ["required", "label", "labelStyle", "error", "labelTooltip", "style", "schemaHasHeading", "numberOfInputs"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var inputStyles = exports.inputStyles = (0, _styledComponents.css)(["width:100%;padding:14px 10px;margin-bottom:8px;border-radius:3px;border:0;font-size:1rem;box-sizing:border-box;color:#fff;box-shadow:none;", ";"], function (props) {
  if (props.inputStyle === "dark") {
    return (0, _styledComponents.css)(["background-color:#062633;&::placeholder,& *::placeholder{color:#12576e;opacity:1 !important;}&:disabled{background-color:#031117;}"]);
  } else if (props.inputStyle === "darker") {
    return (0, _styledComponents.css)(["background-color:#061e26;&::placeholder,& *::placeholder{color:#12576e;opacity:1 !important;}&:disabled{background-color:#000000;}"]);
  } else if (props.inputStyle === "light") {
    return (0, _styledComponents.css)(["color:#000000;background-color:#fff;&::placeholder,& *::placeholder{color:#ccc;opacity:1 !important;}&:disabled{background-color:#e6e6e6;}"]);
  } else if (props.inputStyle === "muted") {
    return (0, _styledComponents.css)(["background-color:#f7f7f7;border:1px solid #e0e0e0;border-radius:3px;color:#666666;&:disabled{background-color:#e6e6e6;}"]);
  } else if (props.inputStyle === "achievement") {
    return (0, _styledComponents.css)(["font-size:1rem;background-color:#fff;color:#0c0c0c;border:1px solid #e6e6e6;border-radius:3px;padding:18px 14px;&::placeholder,& *::placeholder{color:#ccc;opacity:1 !important;}&:focus,&:focus-within{outline:none;bordercolor:#4a4a4a;}"]);
  } else if (props.inputStyle === "sm_minimal") {
    return (0, _styledComponents.css)(["border-radius:0px;font-size:", "rem;background-color:transparent;color:#000;padding:4px 0;border:0px;border-bottom:1px solid #e6e6e6;&::placeholder,& *::placeholder{color:#949494;opacity:1 !important;}height:auto;&:focus,&:focus-within{outline:none;border-bottom:1px solid #00bbd5;}"], 14 / 16);
  } else if (props.inputStyle === "transparent") {
    return (0, _styledComponents.css)(["color:#000000;background:transparent;"]);
  } else if (props.inputStyle === 'ehp') {
    return (0, _styledComponents.css)(["", ""], _ui.InputStyles);
  }
});
var Input = exports.Input = _styledComponents["default"].input.withConfig({
  displayName: "TextInput__Input"
})(["", ";"], (0, _styledComponents.css)(["", ";"], inputStyles));
var PasswordInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TextInput__PasswordInputWrapper"
})(["", ";display:flex;align-items:center;justify-content:stretch;cursor:text;&:focus-within{box-shadow:0 0 5px #0f5fbc;border:1px solid #0f5fbc;color:#2a3f53;}"], (0, _styledComponents.css)(["", ";"], inputStyles));
var PasswordInnerInput = _styledComponents["default"].input.withConfig({
  displayName: "TextInput__PasswordInnerInput"
})(["padding:0;border:0;outline:0;box-shadow:0;flex:1;height:100%;&:focus{padding:0;border:0;outline:0;box-shadow:none;}"]);
var ShowPasswordIcon = _styledComponents["default"].img.withConfig({
  displayName: "TextInput__ShowPasswordIcon"
})(["cursor:pointer;flex:0 0 auto;"]);
var PasswordInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref, _ref2) {
  var className = _ref.className,
    style = _ref.style,
    inputStyle = _ref.inputStyle,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    // Prefetch the "hide password" icon so there is no white flash after
    //   clicking on it.
    new Image().src = '/images/password-hide-icon.svg';
  }, []);
  return /*#__PURE__*/_react["default"].createElement(PasswordInputWrapper, {
    style: _objectSpread({
      position: 'relative'
    }, style),
    onClick: function onClick() {
      // Ensure that clicking anywhere in the wrapper focuses the input.
      inputRef.current.focus();
    },
    className: className,
    inputStyle: inputStyle
  }, /*#__PURE__*/_react["default"].createElement(PasswordInnerInput, (0, _extends2["default"])({
    ref: function ref(el) {
      if (_ref2) {
        _ref2.current = el;
      }
      inputRef.current = el;
    }
  }, props, {
    type: showPassword ? 'text' : 'password'
  })), /*#__PURE__*/_react["default"].createElement(ShowPasswordIcon, {
    src: "/images/password-".concat(showPassword ? 'hide' : 'show', "-icon.svg"),
    alt: "".concat(showPassword ? 'Hide' : 'Show', " password"),
    onClick: function onClick(evt) {
      setShowPassword(function (p) {
        return !p;
      });
      evt.stopPropagation();
    }
  }));
});
var TextInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var required = _ref3.required,
    label = _ref3.label,
    labelStyle = _ref3.labelStyle,
    error = _ref3.error,
    labelTooltip = _ref3.labelTooltip,
    style = _ref3.style,
    schemaHasHeading = _ref3.schemaHasHeading,
    numberOfInputs = _ref3.numberOfInputs,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AccessibleInputLabel["default"], {
    required: required,
    labelFor: rest.id || rest.name,
    label: label,
    labelTooltip: labelTooltip,
    labelStyle: labelStyle || rest.inputStyle,
    omitRequiredAsterisk: rest.omitRequiredAsterisk
  }), rest.type === 'password' ? /*#__PURE__*/_react["default"].createElement(PasswordInput, rest) : /*#__PURE__*/_react["default"].createElement(Input, (0, _extends2["default"])({
    ref: ref,
    required: required,
    type: "text"
  }, rest)));
});
TextInput.propTypes = {
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  labelTooltip: _propTypes["default"].object,
  inputStyle: _propTypes["default"].oneOf(_constants.TextInputTypes),
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].object,
  error: _propTypes["default"].string,
  config: _propTypes["default"].object
};
TextInput.defaultProps = {
  inputStyle: "achievement",
  labelStyle: "gray",
  style: {},
  error: "",
  value: ""
};
var _default = exports["default"] = TextInput;